module.exports = __webpack_public_path__ + "static/media/tick-thin-blue.8dc59e88.svg";